module.exports = __webpack_public_path__ + "media/ja_jp_s2_Fumiko.b33ba1d4.oga";